import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { Seo } from './components/Seo';
import { Analytics } from './components/Analytics';
import { Home } from './pages/Home';
import { How } from './pages/How';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Blog } from './pages/Blog';
import { Post } from './pages/Post';
import { OgCard } from './pages/OgCard';
import { FaviconCard } from './pages/FaviconCard';
function Shell() {
  const location = useLocation();
  useEffect(() => {
    // A hash targets a section once the new page has laid out; otherwise land
    // at the top instantly rather than animating from the previous page.
    const target = location.hash ? document.getElementById(location.hash.slice(1)) : null;
    if (target) {
      target.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [location.pathname, location.hash, location.search]);
  return <div className="frame" data-id="element-0" data-mp="3mjztd6hzp62c">
      <div className="rail" data-id="element-1" data-mp="3mj6jhwnqi0fz">
        <Seo pathname={location.pathname} data-id="element-2" data-mp="3rbrcivytg9ig" />
        <Analytics pathname={location.pathname} data-id="element-3" data-mp="3rd1a7k1rbfok" />
        <Nav data-id="element-4" data-mp="6hp9c27i9cj" />
        <main data-id="element-5" data-mp="4wvvprmowg9">
          <Routes data-id="element-6" data-mp="4n725ibkvc5">
            <Route path="/" element={<Home data-id="element-8" data-mp="2zl3azit8d249" />} data-id="element-7" data-mp="56qjqnmbrsa" />
            <Route path="/how" element={<How data-id="element-10" data-mp="2zmenc70qri6z" />} data-id="element-9" data-mp="2zlli5ahfl0qy" />
            <Route path="/about" element={<About data-id="element-12" data-mp="33mf2xuzktzfm" />} data-id="element-11" data-mp="2zn69yscd25l4" />
            <Route path="/blog" element={<Blog data-id="element-14" data-mp="33n6xr3lcnt4u" />} data-id="element-13" data-mp="33lx02fiesmyq" />
            {/* Unknown slugs render their own not-found with a route back to Signals. */}
            <Route path="/blog/:slug" element={<Post data-id="element-16" data-mp="3dkl60fx4dbm2" />} data-id="element-15" data-mp="38nup5qdhqbzl" />
            <Route path="/contact" element={<Contact data-id="element-18" data-mp="3dm5y7yvyoigr" />} data-id="element-17" data-mp="3dlw6o6v9q38y" />
            {/* Legacy .html paths from the original static site. */}
            <Route path="/index.html" element={<Navigate to="/" replace data-id="element-20" data-mp="sunbk38ws6eh" />} data-id="element-19" data-mp="nvaq9mxor7e0" />
            <Route path="/home.html" element={<Navigate to="/" replace data-id="element-22" data-mp="swqaxdvybbvv" />} data-id="element-21" data-mp="stc8y6r794oy" />
            <Route path="/how.html" element={<Navigate to="/how" replace data-id="element-24" data-mp="34x1hg4gh72u" />} data-id="element-23" data-mp="35yn2ej3lbyt" />
            <Route path="/how-it-works" element={<Navigate to="/how" replace data-id="element-26" data-mp="3ubrhck3tkg3z" />} data-id="element-25" data-mp="3uct0lbuzo8ws" />
            <Route path="/how-it-works.html" element={<Navigate to="/how" replace data-id="element-28" data-mp="d4xqnip0ahey" />} data-id="element-27" data-mp="3uf5i5nwu4h9b" />
            <Route path="/about.html" element={<Navigate to="/about" replace data-id="element-30" data-mp="85uktw17c75x" />} data-id="element-29" data-mp="d2l9h7r2ob2y" />
            <Route path="/contact.html" element={<Navigate to="/contact" replace data-id="element-32" data-mp="3gle8mfj3sxdl" />} data-id="element-31" data-mp="8648ve2os48z" />
            <Route path="/blog.html" element={<Navigate to="/blog" replace data-id="element-34" data-mp="3gja887keygi2" />} data-id="element-33" data-mp="3gm647qcpav3v" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-36" data-mp="3bnuurgqbimm6" />} data-id="element-35" data-mp="3bn2z65wq0ovw" />
          </Routes>
        </main>
        <Footer data-id="element-37" data-mp="3qbfud0nzi3pc" />
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-38" data-mp="3lkr4tqvv7gsu">
      <Routes data-id="element-39" data-mp="3lk7pmhxln6ii">
        {/* Rendered outside the site frame: they're images to capture, not pages. */}
        <Route path="/og" element={<OgCard data-id="element-41" data-mp="2xt27tx83m45k" />} data-id="element-40" data-mp="2xtv6eawwlncm" />
        <Route path="/favicon" element={<FaviconCard data-id="element-43" data-mp="2swbuvirlbood" />} data-id="element-42" data-mp="2xsk289zjqdkz" />
        <Route path="*" element={<Shell data-id="element-45" data-mp="2svjza7xztqy3" />} data-id="element-44" data-mp="2sv0odb6rg2tk" />
      </Routes>
    </BrowserRouter>;
}